module.exports = __webpack_public_path__ + "img/blue_040.01db05c4.png";